<div class="row rounded-card" id="settings-export-columns">
  <div class="flex flex-wrap justify-between items-end mb-4" id="setting-view-header-wr">
    <div class="flex flex-col">
      <h2 data-testid="exports-settings-title">
        {{ 'SYSTEM_SETTINGS.MODULES.EXPORT_COLUMNS_SETTINGS_TITLE' | translate }}
      </h2>
    </div>

    <div class="flex flex-col col-12">
      <span data-testid="exports-settings-subtitle" class="block text-base">
        {{ 'SYSTEM_SETTINGS.MODULES.EXPORT_COLUMNS_SETTINGS_SUBTITLE' | translate }}
      </span>
    </div>
  </div>

  <hr class="w-full mb-1 mt-2 border-t">

  <div class="mt-1 col-12">
    <h3 data-testid="exports-settings-sales-title">
      {{ 'SYSTEM_SETTINGS.MODULES.SALES_COLUMNS_TITLE' | translate }}:
    </h3>
  </div>

  @for (column of getColumns(TableSettingService.SalesTableName); track column; let i = $index) {
    <div class="col-md-3 col-sm-6 mt-1 flex items-center gap-2">
      <p-checkbox [attr.data-testid]="'value-' + column.header" [inputId]="'export-sales-column-' + i" name="modules-columns" [value]="column.field" [(ngModel)]="salesValues" />
      <label [for]="'export-sales-column-' + i">
        {{ column.header }}
      </label>
      <input type="number" min="0" step="1" [(ngModel)]="column.order" [name]="'column-order-' + i" placeholder="—" class="form-control" style="width: 70px"/>
    </div>
  }

  <hr class="w-full mb-3 mt-6 border-t">

  <div class="mt-1 col-12">
    <h3 data-testid="exports-settings-retailers-title">
      {{ 'SYSTEM_SETTINGS.MODULES.RETAILERS_COLUMNS_TITLE' | translate }}:
    </h3>
  </div>

  @for (column of getColumns(TableSettingService.RetailsTableName); track column; let i = $index) {
    <div class="col-md-3 col-sm-6 mt-1 flex items-center gap-2"
      >
      <p-checkbox [attr.data-testid]="'value-' + column.header" [inputId]="'export-retailers-column-' + i" name="modules-columns" [value]="column.field" [(ngModel)]="retailsValues" />
      <label [for]="'export-retailers-column-' + i">
        {{ column.header }}
      </label>
      <input type="number" min="0" step="1" [(ngModel)]="column.order" [name]="'column-order-' + i" placeholder="—" class="form-control" style="width: 70px"/>
    </div>
  }

  <hr class="w-full mb-3 mt-6 border-t">

  <div class="mt-1 col-12">
    <h3 data-testid="exports-settings-items-title">
      {{ 'SYSTEM_SETTINGS.MODULES.ITEMS_COLUMNS_TITLE' | translate }}:
    </h3>
  </div>

  @for (column of getColumns(TableSettingService.ItemsTableName); track column; let i = $index) {
    <div class="col-md-3 col-sm-6 mt-1 flex items-center gap-2"
      >
      <p-checkbox [attr.data-testid]="'value-' + column.header" [inputId]="'export-items-column-' + i" name="modules-columns" [value]="column.field" [(ngModel)]="itemsValues" />
      <label [for]="'export-items-column-' + i">
        {{ column.header }}
      </label>
      <input type="number" min="0" step="1" [(ngModel)]="column.order" [name]="'column-order-' + i" placeholder="—" class="form-control" style="width: 70px"/>
    </div>
  }

  <hr class="w-full mb-3 mt-6 border-t">

  <div class="mt-1 col-12">
    <h3 data-testid="exports-settings-inventories-title">
      {{ 'SYSTEM_SETTINGS.MODULES.INVENTORY_COLUMNS_TITLE' | translate }}:
    </h3>
  </div>

  @for (column of getColumns(TableSettingService.InventoriesTableName); track column; let i = $index) {
    <div class="col-md-3 col-sm-6 mt-1 flex items-center gap-2"
      >
      <p-checkbox [attr.data-testid]="'value-' + column.header" [inputId]="'export-inventories-column-' + i" name="modules-columns" [value]="column.field" [(ngModel)]="inventoriesValues" />
      <label [for]="'export-inventories-column-' + i">
        {{ column.header }}
      </label>
      <input type="number" min="0" step="1" [(ngModel)]="column.order" [name]="'column-order-' + i" placeholder="—" class="form-control" style="width: 70px"/>
    </div>
  }

  <hr class="w-full mb-3 mt-6 border-t">

  <div class="mt-1 col-12">
    <h3 data-testid="exports-settings-shipments-title">
      {{ 'SYSTEM_SETTINGS.MODULES.SHIPMENTS_COLUMNS_TITLE' | translate }}:
    </h3>
  </div>

  @for (column of getColumns(TableSettingService.ShipmentsTableName); track column; let i = $index) {
    <div class="col-md-3 col-sm-6 mt-1 flex items-center gap-2"
      >
      <p-checkbox [attr.data-testid]="'value-' + column.header" [inputId]="'export-shipments-column-' + i" name="modules-columns" [value]="column.field" [(ngModel)]="shipmentsValues" />
      <label [for]="'export-shipments-column-' + i">
        {{ column.header }}
      </label>
      <input type="number" min="0" step="1" [(ngModel)]="column.order" [name]="'column-order-' + i" placeholder="—" class="form-control" style="width: 70px"/>
    </div>
  }

  <hr class="w-full mb-3 mt-6 border-t">

  <div class="mt-1 col-12">
    <h3 data-testid="exports-settings-customers-title">
      {{ 'SYSTEM_SETTINGS.MODULES.CUSTOMERS_COLUMNS_TITLE' | translate }}:
    </h3>
  </div>

  @for (column of getColumns(TableSettingService.CustomersTableName); track column; let i = $index) {
    <div class="col-md-3 col-sm-6 mt-1 flex items-center gap-2"
      >
      <p-checkbox [attr.data-testid]="'value-' + column.header" [inputId]="'export-customers-column-' + i" name="modules-columns" [value]="column.field" [(ngModel)]="customersValues" />
      <label [for]="'export-customers-column-' + i">
        {{ column.header }}
      </label>
      <input type="number" min="0" step="1" [(ngModel)]="column.order" [name]="'column-order-' + i" placeholder="—" class="form-control" style="width: 70px"/>
    </div>
  }

  <hr class="w-full mb-3 mt-6 border-t">

  <div class="mt-1 col-12">
    <h3 data-testid="exports-settings-users-title">
      {{ 'SYSTEM_SETTINGS.MODULES.USERS_COLUMNS_TITLE' | translate }}:
    </h3>
  </div>

  @for (column of getColumns(TableSettingService.UsersTableName); track column; let i = $index) {
    <div class="col-md-3 col-sm-6 mt-1 flex items-center gap-2"
      >
      <p-checkbox [attr.data-testid]="'value-' + column.header" [inputId]="'export-users-column-' + i" name="modules-columns" [value]="column.field" [(ngModel)]="usersValues" />
      <label [for]="'export-users-column-' + i">
        {{ column.header }}
      </label>
      <input type="number" min="0" step="1" [(ngModel)]="column.order" [name]="'column-order-' + i" placeholder="—" class="form-control" style="width: 70px"/>
    </div>
  }

  <hr class="w-full mb-3 mt-6 border-t">

  <div class="mt-1 col-12">
    <h3 data-testid="exports-settings-cardorders-title">
      {{ 'SYSTEM_SETTINGS.MODULES.CARD_ORDER_COLUMNS_TITLE' | translate }}:
    </h3>
  </div>

  @for (column of getColumns(TableSettingService.CardOrdersTableName); track column; let i = $index) {
    <div class="col-md-3 col-sm-6 mt-1 flex items-center gap-2"
      >
      <p-checkbox [attr.data-testid]="'value-' + column.header" [inputId]="'export-card-orders-column-' + i" name="modules-columns" [value]="column.field" [(ngModel)]="cardOrdersValues" />
      <label [for]="'export-card-orders-column-' + i">
        {{ column.header }}
      </label>
      <input type="number" min="0" step="1" [(ngModel)]="column.order" [name]="'column-order-' + i" placeholder="—" class="form-control" style="width: 70px"/>
    </div>
  }

  <div class="col-12 mt-6 mb-4 pt-8 border-t">
    <div class="flex items-center justify-end gap-3">
      <button data-testid="update-table-settings-btn" class="btn primary-btn" (click)="updateModulesSettings()">
        {{ 'SYSTEM_SETTINGS.MODULES.SAVE_TABLES_COLUMNS_CHANGES' | translate }}
      </button>
    </div>
  </div>
</div>
